import { Link, usePage } from '@inertiajs/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/free-solid-svg-icons'

export default function NotificationBell({ href, className = 'hover:bg-gray-100 text-gray-500', badgeClass = 'bg-red-500' }) {
  const { current_user } = usePage().props
  const count = current_user?.unread_notifications || 0

  return (
    <Link href={href} className={`relative w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${className}`} title="Notifikasi">
      <FontAwesomeIcon icon={faBell} className="w-4 h-4" />
      {count > 0 && (
        <span className={`absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold text-white flex items-center justify-center ${badgeClass}`}>
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  )
}
